import React, { useState, useEffect } from 'react';
//import ReactPixel from 'react-facebook-pixel';
import { setSearchFormData } from '@/redux/actions/searchFormDataActions';
import { format, addDays } from 'date-fns';
import { saveCheckout } from '@/services/reservationService';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { sendReservationMail } from '@/services/emailService';
import { fetchUserPaymentMethods } from '@/services/userPaymentMethodsService';
import { COWORKING } from '@/types/spaceTypes.constants';
import { setUserCardList } from '@/redux/actions/cardListActions';

export const useReservationForm = spaceDetail => {
  const [isLoading, setIsLoading] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const userCardList = useSelector(state => state.userCardList);
  const languageData = useSelector(state => state.lenguage?.lang);
  const userData = useSelector(state => state.user);
  const searchFormData = useSelector(state => state.searchFormData);
  const tomorrow = format(addDays(new Date(), 1), 'yyyy-MM-dd');
  const startTimeFromRedux = searchFormData?.startTime;
  const endTimeFromRedux = searchFormData?.endTime;
  const guestArray = searchFormData?.guests;
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const mapPaymentMethods = data =>
    data.map(item => ({
      id: item.token,
      paymentMethod: item.token,
      customerId: item.customerId,
      isDefault: item.isDefault === '1',
      card: {
        brand: 'card',
        last4: '****',
      },
      cardNumber: item.cardNumber,
      icon: item.icon,
      details: item.details,
      isSelected: item.isSelected,
    }));

  const loadPaymentMethods = async () => {
    try {
      const data = await fetchUserPaymentMethods();
      const mapped = mapPaymentMethods(data);
      dispatch(setUserCardList(mapped));
    } catch (err) {
      console.error('Error cargando métodos de pago', err);
    }
  };

  const parseMainImage = mainImageStr => {
    try {
      const images = JSON.parse(mainImageStr);
      if (Array.isArray(images) && images.length > 0) {
        return encodeURI(images[0].trim());
      }
    } catch (error) {
      console.error('Error al parsear main_image:', error);
    }
    return 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c';
  };

  const doCheckout = async (spaceDetail, totalPrice, selectedCard) => {
    console.log('aqui selected card', selectedCard);
    setHasSubmitted(true);
    if (!guestArray || guestArray.length === 0) {
      setErrorMessage(
        languageData === 'EN'
          ? 'No guest selected'
          : 'No hay ningún invitado seleccionado',
      );
      return;
    }

    if (!selectedCard) {
      setErrorMessage(
        languageData === 'EN'
          ? 'No payment method selected'
          : 'No hay ningún método de pago seleccionado',
      );
      return;
    }

    setErrorMessage('');
    setIsLoading(true);

    try {
      const parsedTotalPrice = parseFloat(totalPrice);
      const amount = Math.round(parsedTotalPrice * 100);
      const currency = spaceDetail?.currency?.toLowerCase();

      const reservation = {
        host_id: 1,
        guest_id: 2,
        space_subtype_relationship: spaceDetail?.id_relationship,
        start_date: searchFormData?.startDate || tomorrow,
        finish_date: searchFormData?.startDate || tomorrow,
        initial_price: parsedTotalPrice,
        final_price: parsedTotalPrice,
        id_state: 1,
        payment_method: 1,
        method_status: 'p',
        method_details: 'Credit Card',
      };

      const defaultCard = selectedCard;
      console.log('VER LA TARJETA GUARDADA: ', defaultCard);

      if (!defaultCard) {
        setErrorMessage(
          languageData === 'EN'
            ? 'No payment method available'
            : 'No hay métodos de pago disponibles',
        );
        return;
      }

      const paymentMethodId = defaultCard?.id;
      const customerId = defaultCard?.customerId;

      const { createdReservation } = await saveCheckout({
        amount,
        currency,
        reservation,
        paymentMethodId,
        customerId,
      });

      if (!createdReservation) {
        setErrorMessage('Hubo un error al procesar el pago');
        return;
      }

      try {
        const templateParams = {
          user_name: userData?.name || 'Usuario',
          reply_to: userData?.email,
          user_email: userData?.email,
          copy_to: 'sistemas@popnest.org',
          booking_number: createdReservation?.transaction_id,
          space_type:
            spaceDetail?.subtype_id === COWORKING
              ? 'Coworking'
              : 'Metting Room',
          booking_date: reservation.start_date,
          booking_time_start: startTimeFromRedux || '8:00 AM',
          booking_time_end: endTimeFromRedux || '7:00 PM',
          space_name: spaceDetail?.space_name,
          amount: parsedTotalPrice + ' ' + spaceDetail?.currency,
          message: '',
          space_address: spaceDetail?.space_address,
          image: parseMainImage(spaceDetail?.main_image),
        };

        await sendReservationMail(templateParams);
        console.log(' Email de reserva enviado correctamente:', templateParams);
      } catch (emailError) {
        console.error(' Error enviando email de reserva:', emailError);
      }

      navigate(
        '/booking-confirmation?transaction_id=' +
          createdReservation?.transaction_id,
      );
    } catch (err) {
      console.error(err);
      setErrorMessage('Error inesperado al procesar la reserva');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const guestsForRedux =
      !guestArray || guestArray.length === 0
        ? [
            {
              id: 1,
              firstName: userData?.name,
              lastName: userData?.lastName,
              email: userData?.email,
              isDefault: true,
              isSelected: true,
            },
          ]
        : guestArray;
    dispatch(
      setSearchFormData({
        ...searchFormData,
        guests: guestsForRedux,
      }),
    );
    if (spaceDetail.length >= 1) {
      setIsLoading(false);
    }
  }, [spaceDetail, userData]);

  useEffect(() => {
    if (userCardList.length === 0) {
      console.log('Se entró aquí y se consultara metodsos de pago a bd');
      loadPaymentMethods();
    } else {
      console.log('No fue necesario entrar a bd');
    }
  }, []);

  return {
    isLoading,
    setIsLoading,
    doCheckout,
    hasSubmitted,
    errorMessage,
  };
};
